import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_entity.scss';
import Dropdown from '../Reusables/Dropdown';
import getResponseEntity from '../actions/Entity.js';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import { useNavigate } from "react-router-dom";

import closeIcon from '../../images/popups/upload/closeicon.png';

function AddEntity(props) {
    const {show, handleClose, getEntityDetails, entityerror, entityId, addentitytoggle, setEnableEntity, enableEntity} = props;
    const navigate = useNavigate();
    const [entityDetails, setEntityDetails] = useState({RelatedEntity: null, RelationShipType: null});
    const [entitiesList, setEntitiesList] = useState([]);
    const [entityLabel, setEntityLabel] = useState("Select Property");
    const [relationLabel, setRelationLabel] = useState("Select Relation");
    const relationshipList = [{id: 1, name: "Child"}, {id: 2, name: "Parent"}];
    const [enable, setEnable] = useState(null);
    useEffect(() => {
        setEntityLabel("Select Property");
        setRelationLabel("Select Relation");
        setEntityDetails({RelatedEntity: null, RelationShipType: null});
    }, [addentitytoggle])

    useEffect(() => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                const path = window.location.href;  
                const pathSplit = path.split('/');
                const id = parseInt(pathSplit[pathSplit.length - 2]);
                const pageType = pathSplit[pathSplit.length - 1];
                console.log(id, pageType);
                getResponseEntity.GetEntityList(`/api/entity/dropdown?isRelation=true&entityId=${id}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        console.log(data.data.data)
                        const entityArray = [];
                        const datas = data.data.data
                        data.data.data.map((entity) => {
                            const entityObject = {id: 0, name: ''}
                            if(!(entityId === entity["idEntities"])) {
                                entityObject.id = entity["idEntities"];
                                entityObject.name = entity["entityName"];
                                entityArray.push(entityObject);
                            }
                            if((entityId === entity["idEntities"]) && datas.length === 1) {
                                setEnable(false);
                            } else {
                                setEnable(true)
                            }
                        })
                        setEntitiesList(entityArray);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [])

    const handleSelectEntity = (id) => {
        setEntityDetails({
            ...entityDetails,
            RelatedEntity: id
        })
    }

    const handleSelectRelation = (type) => {
        setEntityDetails({
            ...entityDetails,
            RelationShipType: type
        })
    }

    const handleSave = () => {
        setEnableEntity(false);
        getEntityDetails(entityDetails);
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='add-entity-popup'
                centered>
                <Modal.Body className='add-entity-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='add-entity-popup-header'>Add Property</div>
                    <div className='add-entity-popup-body'>
                        <div className='error-message'>{entityerror}</div>
                        <div className='entity-container'>
                            <label className='required'>Name</label>
                            <Dropdown className="entity-dropdown" label={entityLabel} selectedItem={(name, id) => handleSelectEntity(id)}
                                handleLabel={(value) => setEntityLabel(value)} list={entitiesList} enable={enable}/>
                        </div>
                        <div className='relationship-container'>
                            <label className='required'>Relationship</label>
                            <Dropdown className="entity-dropdown" label={relationLabel} selectedItem={(name, id) => handleSelectRelation(name)}
                                handleLabel={(value) => setRelationLabel(value)} list={relationshipList} enable={enable}/>
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button disabled={enableEntity ? false : true} className={enableEntity ? 'enable' : 'disable'} onClick={handleSave}>Add</button>
                    </div>            
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddEntity;